import { COMMENT_POST_TYPE } from "../constants";

const commentPostReducer = (state = {}, action) => {
   switch (action.type) {
      case COMMENT_POST_TYPE.FETCH:
         return action.payload;
      case COMMENT_POST_TYPE.DELETE:
         return state.filter(item => item.id !== action.payload);
      default:
         return state;
   }
};

export default commentPostReducer